// Router state key carrying the screen an incident was opened from.
export const INCIDENT_ORIGIN_STATE_KEY = "returnTo";

export const buildIncidentOriginState = (location: {
  pathname: string;
  search?: string;
}) => ({
  [INCIDENT_ORIGIN_STATE_KEY]: `${location.pathname}${location.search ?? ""}`,
});

// Only in-app portal screens are valid return targets.
export const getSafeReturnPath = (value: unknown): string | null =>
  typeof value === "string" && value.startsWith("/user/") ? value : null;
